var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.wrapperComponent,{tag:"component",attrs:{"value":_vm.valueText}},[_c(_vm.component,_vm._b({tag:"component",staticClass:"epb-audit-details-field-value"},'component',_vm.componentProps,false),[_vm._v("\n    "+_vm._s(_vm.valueText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }